import { ArrowRight, Droplets, House, Briefcase, Leaf } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function EnvironmentallyFriendlyCleaningForYourProperty() {
  return <section className="relative min-h-[85vh] flex items-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/comprehensive_property_services_hero.png)]" aria-hidden="true">
        <div className="absolute inset-0 bg-black/10" />
      </div>

      {}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-3xl">
          {}
          <div className="inline-flex items-center gap-2 bg-primary/90 backdrop-blur-sm text-primary-foreground px-4 py-2 rounded-lg shadow-soft mb-6 animate-fade-in-up">
            <Droplets className="size-5" />
            <span className="text-sm font-medium tracking-wide">
              Professionelle Dienstleistungen
            </span>
          </div>

          {}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-snug mb-6 animate-fade-in-up-delay-100 bg-background/80 backdrop-blur-md px-6 py-4 rounded-lg inline-block border border-muted/20 shadow-soft">
            Umfassende Dienstleistungen für Ihr Objekt
          </h1>

          {}
          <p className="text-lg sm:text-xl text-foreground leading-relaxed mb-8 max-w-2xl animate-fade-in-up-delay-200 bg-background/90 backdrop-blur-md px-6 py-4 rounded-lg border border-muted/20 shadow-soft">
            Münsterland Industrieservice UG bietet vier Kernbereiche: 
            Flächenreinigung ohne chemische Zusätze, Hausmeistertätigkeiten 
            im nicht handwerkspflichtigen Bereich, professionelle Gartenpflege 
            sowie Bürotätigkeiten und Hilfeleistungen im Bereich Büroorganisation.
          </p>

          {}
          <div className="grid sm:grid-cols-2 gap-4 mb-10 animate-fade-in-up-delay-200">
            <div data-index={0} className="flex items-start gap-3 bg-background/80 backdrop-blur-md border border-muted/20 rounded-lg p-4 shadow-soft hover-lift">
              <div className="flex items-center justify-center size-10 rounded-lg bg-primary/10 text-primary shrink-0">
                <Droplets className="size-5" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1">
                  Flächenreinigung
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Ohne chemische Zusätze – umweltfreundlich und materialschonend
                </p>
              </div>
            </div>

            <div data-index={1} className="flex items-start gap-3 bg-background/80 backdrop-blur-md border border-muted/20 rounded-lg p-4 shadow-soft hover-lift">
              <div className="flex items-center justify-center size-10 rounded-lg bg-primary/10 text-primary shrink-0">
                <House className="size-5" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1">
                  Hausmeisterservice
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Tätigkeiten im nicht handwerkspflichtigen Bereich
                </p>
              </div>
            </div>

            <div data-index={2} className="flex items-start gap-3 bg-background/80 backdrop-blur-md border border-muted/20 rounded-lg p-4 shadow-soft hover-lift">
              <div className="flex items-center justify-center size-10 rounded-lg bg-primary/10 text-primary shrink-0">
                <Leaf className="size-5" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1">
                  Gartenpflege
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Professionelle Pflege von Grünanlagen und Außenbereichen
                </p>
              </div>
            </div>

            <div data-index={3} className="flex items-start gap-3 bg-background/80 backdrop-blur-md border border-muted/20 rounded-lg p-4 shadow-soft hover-lift">
              <div className="flex items-center justify-center size-10 rounded-lg bg-primary/10 text-primary shrink-0">
                <Briefcase className="size-5" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1">
                  Büroorganisation
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Bürotätigkeiten und Hilfeleistungen für reibungslose Abläufe
                </p>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-wrap items-center gap-4 animate-fade-in-up-delay-200">
            <Link to="/KontaktPage">
              <Button size="lg" className="shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5">
                Kostenloses Angebot anfordern
                <ArrowRight className="size-5" />
              </Button>
            </Link>

            <Link to="/ReinigungPage">
              <Button variant="outline" size="lg" className="bg-background/80 backdrop-blur-md border-border shadow-soft hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)]">
                Alle Leistungen ansehen
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}